import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  return (
    <footer
      style={{
        marginTop: "40px",
        padding: "20px",
        borderTop: "1px solid #ccc",
        textAlign: "center",
        fontSize: "14px",
      }}
    >
      <p>{t("footer_copyright")}</p>

      <div style={{ marginTop: "10px" }}>
        <Link to="./Privacy">{t("footer_privacyPolicy")}</Link>
        {" | "}
        <Link to="./Terms">{t("footer_termsOfService")}</Link>
      </div>
    </footer>
  );
}

export default Footer;